// extracted by mini-css-extract-plugin
export default {"container1":"HomeLayout_container1__ro35Y","container2":"HomeLayout_container2__wP40M"};